export const CREATE_SHIPMENT_API =
  "/joms/api/internal/v1/shipment/create-shipment";

export const GET_DO_SHIPMENT_DETAILS_API =
  "/joms/api/external/v1/plant-supply/do-shipment-details";
